import {action, computed, observable, makeObservable, runInAction} from 'mobx';
import {enumToValues} from '@netx/core-next/utils/enum';
import {RuleModel} from '../baseModel';
import {
	ContentsType,
	SearchTypeContents,
	TSearchTypeContents,
} from './constants';
import {contentsRuleDefaults} from './defaults';
import type {ContentsRule} from './types';
import {validateContentsRule} from './validate';

export class ContentsRuleModel
	extends RuleModel<TSearchTypeContents>
	implements ContentsRule
{
	readonly elementType = SearchTypeContents;
	elementSubType1: ContentsType = contentsRuleDefaults.elementSubType1;
	elementSubType2: 0 = contentsRuleDefaults.elementSubType2;
	elementValue1 = contentsRuleDefaults.elementValue1;
	elementValue2: '' = contentsRuleDefaults.elementValue2;
	elementValue3: '' = contentsRuleDefaults.elementValue3;

	get elementSubType1Options() {
		return enumToValues(ContentsType);
	}

	get isValid() {
		const validation = validateContentsRule(this);
		this.setValidationErrors(this.dirty && validation ? validation : undefined);
		if (!validation) return true;
		return false;
	}

	constructor(params?: Partial<Omit<ContentsRule, 'elementType'>>) {
		super();

		runInAction(() => {
			Object.assign(this, {...contentsRuleDefaults, ...params});
		});

		makeObservable(this, {
			isValid: computed,
			elementSubType1: observable,
			elementSubType1Options: computed,
			elementValue1: observable,
			setElementSubType1: action,
			setElementValue1: action,
		});
	}

	setElementSubType1(elementSubType1: ContentsType) {
		this.elementSubType1 = elementSubType1;
	}

	/** stubbed */
	setElementSubType2() {}

	/**
	 * Set contents
	 * @param elementValue1 contents
	 */
	setElementValue1(elementValue1: string) {
		this.elementValue1 = elementValue1;
		this.dirty = true;
	}

	/** stubbed */
	setElementValue2() {}

	/** stubbed */
	setElementValue3() {}
}

export default ContentsRuleModel;
